import notify from 'devextreme/ui/notify';
import {alert} from 'devextreme/ui/dialog';
import * as FileSaver from 'file-saver';

export class FileUtils {
  public static convertFileToBase64(file: File): Promise<string> {
    return new Promise<string>(resolve => {
      const reader = new FileReader();

      reader.onloadend = () => {
        return resolve(reader.result as string);
      };

      reader.readAsDataURL(file);
    });
  }

  public static handlePopupBlocker(windowRef: Window) {
    if (!windowRef || windowRef.closed || typeof windowRef.closed === 'undefined') {
      alert(`
            <p>Your browser has prevented a popup window from opening. <br/>
             Please, disable popup blocker for current site.</p>
            <ul>
                <li><a href="https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DDesktop&hl=en#zippy=%2Callow-pop-ups-from-a-site">Chrome</a></li>
                <li><a href="https://support.apple.com/guide/safari/websites-ibrwe2159f50/14.0/mac/11.0">Safari</a></li>
                <li><a href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting">Firefox</a></li>
                <li><a href="https://support.microsoft.com/en-us/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5">Edge</a></li>
            </ul>
          `, 'Popup blocker').then();
    }
  }

  public static validateFile(event: InputEvent, component: any): Promise<string> | boolean {
    if (!event.target) {
      notify('No file found.', 'error');
      return false;
    }
    const htmlInputElement = event.target as HTMLInputElement;
    if (!htmlInputElement || !htmlInputElement.files || !htmlInputElement.files[0]) {
      notify('No file found.', 'error');
      return false;
    }
    const file: File = htmlInputElement.files[0];
    if (Number.parseInt((file.size / 1024 / 1024).toFixed(4)) > 25) {
      notify('Only 25 MB files allowed.', 'error');
      return false;
    }
    component.isUploading = true;
    component.isLoading = true;
    return FileUtils.convertFileToBase64(file);
  }

  public static pdfRequestHandler(blob: Blob, component: any, invokedFromGrid = false) {
    if (component.pwaDetectorService.isPWA()) {
      FileSaver.saveAs(blob);
    } else {
      const ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
        ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/),
        ieEDGE = navigator.userAgent.match(/Edge/g),
        ieVer = (ie ? ie[1] : (ie11 ? 11 : (ieEDGE ? 12 : -1)));

      if (ie && ieVer < 10) {
        window.alert('This browser doesn\'t support this feature.');
        component.isLoading = false;
        return;
      }

      if (ieVer > -1) {
        window.navigator.msSaveBlob(blob, 'Results.pdf');
      } else {
        if (window.webkitURL) {
          const fileURL = window.webkitURL.createObjectURL(blob);
          const ref = window.open(fileURL, '_blank');
          if (ref) {
            FileUtils.handlePopupBlocker(ref);
          }
        } else if (window.URL) {
          const fileURL = URL.createObjectURL(blob);
          const ref = window.open(fileURL, '_blank');
          if (ref) {
            FileUtils.handlePopupBlocker(ref);
          }
        } else {
          window.alert('This browser doesn\'t support this feature.');
        }
      }
    }
    component.isLoading = false;
    if (invokedFromGrid) {
      component.dxDataGridComponent.instance.endCustomLoading();
    }
  }
}
